import styled from '@emotion/styled';
import { AppBar, Box, Button, Card, CircularProgress, Dialog, Divider, IconButton, Slide, Toolbar, Typography } from '@mui/material'
import React from 'react'
import { VirtuosoGrid } from 'react-virtuoso'
import { AllMoshaveranDispatch } from './model';
import AutoSizer from 'react-virtualized-auto-sizer';
import '../../../../../../Util/ext'
import AllMoshaveranState from '../../State/AllMoshaveranState';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const ItemContainer = styled.div`
  padding: 0.5rem;
  width: 50%;
  display: flex;
  flex: none;
  align-content: stretch;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 50%;
  }

  @media (max-width: 300px) {
    width: 100%;
  }
`

const ItemWrapper = styled.div`
  flex: 1;
  text-align: center;
  font-size: 80%;
  padding: 1rem 1rem;
  border: 1px solid var(gray);
  white-space: nowrap;
`

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

class AllMoshaveranUI extends React.PureComponent<{}>{

    componentDidMount(): void {
        let dispatcher: AllMoshaveranDispatch = (this.props as any).dispatcher
        dispatcher.fetchAllMoshaveranList()
    }

    render() {

        let dispatcher: AllMoshaveranDispatch = (this.props as any).dispatcher
        let state: AllMoshaveranState = (this.props as any).state

        let html: JSX.Element

        if (state.loading && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else if (state.data && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات یافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetchAllMoshaveranList()
                }}>تلاش مجدد</Button>
            </Box>
        } else if (state.error) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات دریافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetchAllMoshaveranList()
                }}>تلاش مجدد</Button>
            </Box>
        } else {

            html = <Box sx={{ pr: 1, pl: 1, pt: 2, pb: 2, height: '100%' , width : '100%' }}>
                <VirtuosoGrid className='none-scrollbar' components={{
                    Item: ItemContainer,
                    List: ListContainer as any,
                    ScrollSeekPlaceholder: ({ height, width, index }) => (
                        <ItemContainer>
                            <ItemWrapper>{'--'}</ItemWrapper>
                        </ItemContainer>
                    ),
                }} totalCount={state.data?.length} itemContent={(index, data, context) => {
                    let value = state.data[index]

                    return <Card key={index} variant="elevation" sx={{ width: '100%', height: '100px', borderRadius: '12px', borderColor: 'transparent' }} >

                        <Box sx={{ width: '100%', height: '100%', flexDirection: 'row' }} display='flex' >
                            <AutoSizer disableHeight style={{ width: '33%' }}>
                                {({ width }: any) => {
                                    return (
                                        <Box
                                            component="img"
                                            sx={{
                                                height: '100px',
                                                width: width / 3,
                                                objectFit: 'cover'
                                            }}
                                            alt='vilage'
                                            src={value.pic}
                                            crossOrigin='anonymous'
                                        />
                                    )
                                }
                                }
                            </AutoSizer>

                            <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                            <Box sx={{ width: '67%', flexDirection: 'column', mr: 0.5 }} display='flex'>

                                <Box sx={{ flexGrow: 0.25, flexDirection: 'column' }} display='flex' justifyContent="center" alignItems="start">
                                    <Typography variant="subtitle2" display="block" gutterBottom  color='primary'>
                                        {value.name}
                                    </Typography>
                                    <Typography variant="subtitle2" display="block" gutterBottom  color='primary'>
                                        {value.phone}
                                    </Typography>
                                </Box>

                            </Box>
                        </Box>


                    </Card>

                }} />
            </Box>
        }

        return (
            <Dialog
                fullScreen
                open={state.show}
                dir="rtl"
                TransitionComponent={Transition} >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => {
                                dispatcher.show()
                            }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ mr: 2, fontFamily: 'font-farsi-logo' }}>
                            ویـــلاگــــرام
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ flexGrow: 1, mr: 2 }} textAlign='start'>
                            : مشاوران
                        </Typography>

                    </Toolbar>
                </AppBar>

                <Box sx={{ width: '100%', height: '100%', flexDirection: 'row' }} display='flex'>
                    {html}
                </Box>
            </Dialog >
        )
    }
}

export default AllMoshaveranUI